import { JURISDICTION_PROFILES } from './profiles';
import { STANDARD_POLICY, type RegulatoryPolicy } from './types';

export function normalizeJurisdictionId(
  raw: string | null | undefined
): string {
  if (!raw) return 'standard';
  const id = String(raw).trim().toUpperCase();
  if (!id || id === 'STANDARD' || id === 'DEFAULT') return 'standard';
  return id;
}

/**
 * Resolve jurisdiction from launch params, then `?jurisdiction=`, else standard.
 */
export function readJurisdictionFromEnvironment(
  launchJurisdiction?: string | null
): string {
  if (launchJurisdiction) {
    return normalizeJurisdictionId(launchJurisdiction);
  }
  if (typeof window !== 'undefined') {
    try {
      const fromQuery = new URLSearchParams(window.location.search).get(
        'jurisdiction'
      );
      if (fromQuery) return normalizeJurisdictionId(fromQuery);
    } catch {
      /* ignore */
    }
  }
  return 'standard';
}

export function resolveRegulatoryPolicy(
  jurisdictionRaw?: string | null
): RegulatoryPolicy {
  const jurisdiction = normalizeJurisdictionId(jurisdictionRaw);
  if (jurisdiction === 'standard') {
    return { ...STANDARD_POLICY };
  }
  const profile = JURISDICTION_PROFILES[jurisdiction];
  if (!profile) {
    console.warn(
      `[regulatory] Unknown jurisdiction "${jurisdiction}", using standard policy`
    );
    return { ...STANDARD_POLICY, jurisdiction };
  }
  return {
    ...STANDARD_POLICY,
    ...profile,
    jurisdiction: profile.jurisdiction ?? jurisdiction,
  };
}
